export const CLI_KIT_VERSION = '4.7.0'
